/** Фирменный зелёный градиент с кубика (Figma 2332:353) — статус «Можно внедрять». */
export const READINESS_READY_CUBE_GRADIENT =
  'linear-gradient(135deg, #D4E157 0%, #7CB342 100%)';

export const READINESS_READY_CUBE_BORDER = 'rgba(124, 179, 66, 0.35)';

export const READINESS_READY_CUBE_TEXT = '#FFFFFF';
